// eslint-disable-next-line
import tw from "twin.macro";
import IndividualCard from "../components/Card/IndividualCard";
import InterviewIcon from "../icons/InterviewIcon.svg";
import TrainIcon from "../icons/TrainIcon.svg";
import wave from "../icons/Wave.svg";
import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const IndividualData = [
  {
    title: "Personal websites",
    icon: InterviewIcon,
    description:
      "Showcasing your skills is as important as possessing them. With our team's attractive and functional website dedicated and terrific customer service truly excel in the market.",
    tech: ["Mock test", "Resources", "Web Content"],
  },
  {
    title: "Portfolio websites",
    icon: InterviewIcon,
    description:
      "Looking for a website to host your online portfolio? we provide hand-picked designs which are suitable for your Portfolio website.",
    tech: ["Mock test", "Resources", "Web Content"],
  },
  {
    title: "Event websites",
    icon: TrainIcon,
    description:
      "Planning an event? Or trying to build online presence for it? We provide services related to all types of events and we make sure that you have all the elements you need Our developers can help you create a beautiful website for selling tickets, and promoting your event online.",
    tech: ["Tech: programming courses", "Soft-skills", "Web Content"],
  },
];

const IndividualSection = () => {
  return (
    <Layout>
      <Seo title="Collection" description="Showcasing your skills is as important as possessing them. With our team's attractive and functional website dedicated and terrific customer service truly excel in the market." />
      <div
        tw="flex flex-col min-h-screen   p-4  pt-32 md:pt-20 md:mt-0  justify-center items-center  space-y-10 bg-no-repeat bg-cover bg-right bg-gray-700 text-white"
        style={{ backgroundImage: `url(${wave})` }}
      >
        <div>
          <h1 tw="text-4xl font-bold">Individual Service</h1>
        </div>

        <div tw="grid md:grid-cols-3  max-w-7xl gap-10">
          {IndividualData.map((CardName, i) => (
            <IndividualCard key={i} {...CardName} />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default IndividualSection;
